<template lang="pug">
.post-meta-group(
  :class="{'--menu': menu, '--menu-open': menu && showMenu}"
)
  template(v-if="menu")
    span.post-meta-group__menu-icon(
      @click="showMenu = !showMenu"
    ) ⋮
    .post-meta-group__menu-items(
      v-if="showMenu"
    )
      slot
  template(v-else)
    slot
</template>

<script>
export default {
  name: 'post-meta-item',
  props: {
    menu: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showMenu: false,
    }
  },
}
</script>

<style lang="sass">
.post-meta-group
  --post-meta-group-menu-icon-padding-v: var(--quarter-padding)
  --post-meta-group-menu-icon-padding-h: var(--half-padding)

.post-meta-group
  & + .post-meta-group
    margin-left: var(--base-padding)

  &:not(.--menu)
    display: flex
    justify-content: space-between
    align-items: center

  &.--menu
    position: relative

  &.--menu-open
    .post-meta-group__menu-icon
      position: relative
      z-index: 81
      background-color: white
      border-color: var(--base-color)
      border-bottom-color: white

  &:not(.--menu-open)
    & > .post-meta-group__menu-icon
      &:hover,
      &:focus
        background-color: var(--accent-color-alpha)

.post-meta-group__menu-icon
  padding: var(--post-meta-group-menu-icon-padding-v) var(--post-meta-group-menu-icon-padding-h)
  border: 1px solid transparent
  border-radius: 0
  cursor: pointer

.post-meta-group__menu-items
  position: absolute
  z-index: 80
  top: calc(1em + var(--post-meta-group-menu-icon-padding-v) * 2)
  right: 0
  display: flex
  padding: var(--post-meta-group-menu-icon-padding-v) var(--post-meta-group-menu-icon-padding-h)
  flex-direction: column
  background-color: white
  border: 1px solid var(--base-color)

  .post-meta-item + .post-meta-item
    margin-left: 0

</style>
